module.exports = __webpack_public_path__ + "static/img/pic_iconbg.962b2e82.png";